import React, { useEffect, useState } from "react";
import OfferForm, { IOffer } from "../Form/OfferForm";
import { deleteReq, formatAxiosErrorMessage, get, putOrThrow } from "../../../../_api";
import { useHistory, useParams } from "react-router-dom";
import {
  Alert,
  Button,
  Container,
  Group,
  Stack,
  Text,
  Title,
} from "@mantine/core";

const EditOffer: React.FC = () => {
  const history = useHistory();
  const params = useParams<{ id: string }>();

  const [offer, setOffer] = useState<IOffer>();
  const [submitError, setSubmitError] = useState<string | null>(null);

  useEffect(() => {
    get(`offers/${params.id}`).then((res) => setOffer(res));
  }, [params.id]);

  const onDelete = async (id: string) => {
    const conf = window.confirm(
      "Czy na pewno chcesz usunąć? Tej operacji nie można cofnąć."
    );
    if (conf) {
      await deleteReq(`offers/${id}`);
      history.push("/offers");
    }
  };
  return (
    <Container size="md" py="xl" pb={250}>
      <Stack gap="lg">
        <Title order={1}>Edytuj ofertę</Title>
        {submitError ? (
          <Alert
            color="red"
            variant="filled"
            title="Nie zapisano zmian"
            withCloseButton
            onClose={() => setSubmitError(null)}
            mb="md"
            style={{ position: "sticky", top: 0, zIndex: 200 }}
          >
            <Text size="sm" c="white" style={{ whiteSpace: "pre-wrap" }}>
              {submitError}
            </Text>
          </Alert>
        ) : null}
        <OfferForm
          offer={offer}
          onSubmit={async (values) => {
            setSubmitError(null);
            try {
              const res = await putOrThrow("offers", {
                ...(values as Record<string, unknown>),
                id: params.id,
              });
              if (res) {
                history.push("/offers");
              }
            } catch (e) {
              setSubmitError(formatAxiosErrorMessage(e));
            }
          }}
        />
        <Group
          justify="flex-end"
          mt="xl"
          pt="lg"
          style={{ borderTop: "1px solid var(--mantine-color-gray-3)" }}
        >
          <Button
            variant="light"
            color="red"
            size="sm"
            radius="md"
            onClick={() => offer && onDelete(offer._id)}
          >
            Usuń
          </Button>
        </Group>
      </Stack>
    </Container>
  );
};

export default EditOffer;
